import { useState, useEffect } from 'react';

const FORM_PERSISTENCE_KEY = 'dentalInsuranceFormData';
const FILE_FIELDS = ['aadhaarCard', 'aadhaarCardBack', 'panCard']; // Add other file fields as needed

export const useFormPersistence = (initialValues) => {
  const [formData, setFormData] = useState(() => {
    // Try to get saved form data from localStorage
    const savedData = localStorage.getItem(FORM_PERSISTENCE_KEY);
    if (savedData) {
      try {
        const parsedData = JSON.parse(savedData);
        // Remove any file fields from persisted data
        const cleanedData = { ...parsedData };
        FILE_FIELDS.forEach(field => {
          if (cleanedData[field]) {
            delete cleanedData[field];
          }
        });
        return cleanedData;
      } catch (error) {
        console.error('Error parsing saved form data:', error);
      }
    }
    return initialValues;
  });

  useEffect(() => {
    // Save form data to localStorage whenever it changes
    // But exclude file fields from being saved
    const dataToSave = { ...formData };
    FILE_FIELDS.forEach(field => {
      if (dataToSave[field]) {
        delete dataToSave[field];
      }
    });
    localStorage.setItem(FORM_PERSISTENCE_KEY, JSON.stringify(dataToSave));
  }, [formData]);

  // Clear form data from localStorage
  const clearFormData = () => {
    localStorage.removeItem(FORM_PERSISTENCE_KEY);
    setFormData(initialValues);
  };

  return { formData, setFormData, clearFormData };
};
